<div class="nav-container">
    <nav class="ts-navbar">
      <div class="ts-nav-container">
        <div class="ts-nav-brand">
          <span class="ts-brand-mark" aria-hidden="true">TA</span><span class="ts-brand-trade">Trade</span>&nbsp;<span class="ts-brand-product">Allocations</span>
          <span class="ts-mobile-only"> &mdash; {{ title.getTitle() }}</span>
        </div>
        <button class="ts-nav-toggler" type="button"
                [attr.aria-expanded]="!isCollapsed" aria-label="Toggle navigation"
                (click)="isCollapsed = !isCollapsed">
          <span class="ts-nav-toggler-icon"></span>
        </button>

        <div class="ts-nav-collapse" [class.ts-hidden]="isCollapsed">
          <ul class="ts-nav-list ts-mr-auto ts-primary-nav">
            <li class="ts-nav-item" *ngIf="auth.isAuthenticated$ | async">
              <a class="ts-nav-link" routerLink="/account/account-detail" routerLinkActive="is-active"
                 [routerLinkActiveOptions]="{ exact: true }" (click)="isCollapsed = true">
                Account Detail
              </a>
            </li>
            <li class="ts-nav-item" *ngIf="auth.isAuthenticated$ | async">
              <a class="ts-nav-link" routerLink="/position" routerLinkActive="is-active" (click)="isCollapsed = true">
                Positions
              </a>
            </li>

            <!-- Fullsize dropdown: show if authenticated -->
            <li class="ts-nav-item ts-dropdown ts-desktop-only" *ngIf="auth.user$ | async as user">
              <a class="ts-nav-link ts-dropdown-toggle" [ngClass]="{ 'is-active': allocationMenuActive }"
                 (click)="toggleAllocateDropdown($event)">
                Allocate Trades
              </a>
              <div class="ts-dropdown-menu" [class.ts-open]="isAllocateDropdownOpen">
                <ng-container *ngFor="let item of allocationMenuItems">
                  <a class="ts-dropdown-item" [routerLink]="item.link" (isActiveChange)="onRouterLinkActive(this)"
                     (click)="isCollapsed = true; closeDropdowns()" routerLinkActive="is-active">
                    {{ item.label }}
                  </a>
                </ng-container>
              </div>
            </li>

            <!-- Responsive dropdown: show if authenticated -->
            <li class="ts-nav-item ts-mobile-only" *ngIf="auth.user$ | async as user">
              <a class="ts-nav-link" [ngClass]="{ 'is-active': allocationMenuActive }">Allocate Trades</a>
            </li>
            <ng-container *ngIf="auth.user$ | async as user">
              <li class="ts-nav-item ts-mobile-only" *ngFor="let item of allocationMenuItems">
                <a class="ts-nav-link ts-submenu" [routerLink]="item.link" (isActiveChange)="onRouterLinkActive(this)"
                   (click)="isCollapsed = true" routerLinkActive="is-active">
                  {{ item.label }}
                </a>
              </li>
            </ng-container>
          </ul>

          <ul class="ts-nav-list ts-desktop-only ts-profile-nav">
            <!-- Login button: show if NOT authenticated -->
            <li class="ts-nav-item" *ngIf="!(auth.isAuthenticated$ | async)">
              <button id="qsLoginBtn" class="ts-btn ts-btn-primary ts-btn-margin" (click)="loginWithRedirect()">
                Log in
              </button>
            </li>

            <!-- Fullsize dropdown: show if authenticated -->
            <li class="ts-nav-item ts-dropdown" *ngIf="auth.user$ | async as user">
              <a class="ts-nav-link ts-dropdown-toggle" id="profileDropDown"
                 (click)="toggleProfileDropdown($event)">
                <img [src]="user.picture" alt="Profile picture" class="ts-nav-avatar"
                     style="width: 35px;" />
              </a>
              <div class="ts-dropdown-menu" [class.ts-open]="isProfileDropdownOpen">
                <div class="ts-dropdown-header">{{ user.name }}</div>
                <a class="ts-dropdown-item ts-dropdown-profile" routerLink="/profile"
                   (click)="isCollapsed = true; closeDropdowns()">
                  <fa-icon [icon]="faUser" class="ts-mr-3"></fa-icon> Profile
                </a>
                <button class="ts-btn-link ts-dropdown-item" (click)="logout()">
                  <fa-icon [icon]="faPowerOff" class="ts-mr-3"></fa-icon> Log out
                </button>
              </div>
            </li>
          </ul>

          <!-- Responsive login button: show if NOT authenticated -->
          <ul class="ts-nav-list ts-mobile-only" *ngIf="!(auth.isAuthenticated$ | async)">
            <button class="ts-btn ts-btn-primary ts-btn-block" id="qsLoginBtn" (click)="loginWithRedirect()">Log in</button>
          </ul>

          <!-- Responsive profile dropdown: show if authenticated -->
          <ul class="ts-nav-list ts-mobile-only ts-profile-mobile" *ngIf="auth.user$ | async as user">
            <li class="ts-nav-item">
              <span class="user-info">
                <img [src]="user.picture" alt="Profile picture" class="ts-nav-avatar ts-inline-block ts-mr-3"
                     style="width: 35px;" />
                <h3 class="ts-inline-block ts-dropdown-header">{{ user.name }}</h3>
              </span>
            </li>
            <li>
              <fa-icon [icon]="faUser" class="ts-mr-3"></fa-icon>
              <a routerLink="/profile" (click)="isCollapsed = true" routerLinkActive="is-active">Profile</a>
            </li>
            <li>
              <fa-icon [icon]="faPowerOff" class="ts-mr-3"></fa-icon>
              <button class="ts-btn-link ts-p-0" (click)="logout()">Log out</button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
  <div></div>